import React, { ReactNode, PureComponent } from 'react'
import { VisuallyHidden } from './ScreenReaderContent.elements'

type Props = {
  children: ReactNode
}

export class ScreenReaderContent extends PureComponent<Props> {
  render() {
    const { children } = this.props
    return (
      <VisuallyHidden>
        {children}
      </VisuallyHidden>
    )
  }
}
